import React from "react";
import Icon from "components/AppIcon";
import { useConfig } from "../../../context/ConfigContext";

const RagTraderRevenue = ({ data, formatCurrency, formatNumber }) => {
  const { config } = useConfig();

  if (!data || !config) return null;

  const ragTraderCalculation = [
    {
      label: "Material Weight",
      value: data.revenue.ragTraderWeight,
      type: "weight",
      suffix: "LBS",
    },
    {
      label: "Rag Trader Rate",
      value: config.rag_trader_rate,
      type: "currency",
      description: "Per pound rate",
    },
    {
      label: "Total Rag Trader Revenue",
      value: data.revenue.ragTraderRevenue,
      type: "currency",
      highlight: true,
      calculation: `${formatNumber(
        data.revenue.ragTraderWeight
      )} LBS × ${formatCurrency(config.rag_trader_rate)}`,
      bgColor: "bg-success-50",
      borderColor: "border-success-200",
    },
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 bg-warning-100 rounded-lg flex items-center justify-center">
          <Icon name="Recycle" size={20} className="text-warning" />
        </div>
        <div>
          <h3 className="text-xl font-heading-semibold text-text-primary">
            Rag Trader Revenue
          </h3>
          <p className="text-sm text-text-secondary">
            Revenue potential from rag trader channel
          </p>
        </div>
      </div>

      {/* Calculation Details */}
      <div className="bg-surface-50 rounded-lg border border-border-light p-6">
        <h4 className="text-lg font-heading-semibold text-text-primary mb-4">
          Revenue Calculation
        </h4>

        <div className="space-y-4">
          {ragTraderCalculation.map((item, index) => (
            <div key={index}>
              <div
                className={`p-3 rounded-lg border ${
                  item.bgColor && item.borderColor
                    ? `${item.bgColor} ${item.borderColor}`
                    : item.highlight
                    ? "bg-surface-50 border-border"
                    : "bg-surface border-border"
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="flex items-center space-x-2">
                      <span className="text-sm font-body-medium text-text-primary">
                        {item.label}
                      </span>
                      {item.description && (
                        <span className="text-xs text-text-tertiary">
                          ({item.description})
                        </span>
                      )}
                    </div>
                    {item.calculation && (
                      <div className="text-xs text-text-tertiary mt-1 font-data">
                        {item.calculation}
                      </div>
                    )}
                  </div>
                  <div className="text-right">
                    <div
                      className={`font-body-medium ${
                        item.highlight
                          ? "text-text-primary"
                          : "text-text-primary"
                      }`}
                    >
                      {item.type === "currency"
                        ? formatCurrency(item.value)
                        : item.type === "weight"
                        ? `${formatNumber(item.value)} ${item.suffix}`
                        : formatNumber(item.value)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Information Card */}
      <div className="bg-info-50 border border-info-200 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <div className="w-6 h-6 bg-info-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
            <Icon name="Info" size={14} className="text-info" />
          </div>
          <div className="flex-1">
            <h4 className="text-sm font-body-medium text-info mb-1">
              About Rag Trader Revenue
            </h4>
            <p className="text-xs text-text-secondary">
              Rag trader revenue is calculated by multiplying the material
              weight by {formatCurrency(config.rag_trader_rate)} per pound. This represents the potential income
              from selling processed textiles through rag trader channels.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RagTraderRevenue;
